import React, { useEffect, useRef, useState } from "react"
import Section from "../../../../core/layout/main/section/Section"
import * as classNames from "./ArticlesPresseParAnnee.module.scss"
import PressCardBlock from "../../blocks/press-card-block/PressCardBlock"

function ArticlesPresseParAnnee({ pageContext }) {
  const { pressArticles } = pageContext
  const progressBarRef = useRef(null)
  const [isMobileView, setIsMobileView] = useState(false)

  const articlesByYear = pressArticles.reduce((acc, article) => {
    const year = new Date(article.attributes.date).getFullYear()
    if (!acc[year]) {
      acc[year] = []
    }
    acc[year].push(article)
    acc[year].sort((a, b) => new Date(b.attributes.date) - new Date(a.attributes.date));
    return acc
  }, {})

  const years = Object.keys(articlesByYear).sort((a, b) => b - a); // Sort years in descending order
  const [currentYearIndex, setCurrentYearIndex] = useState(0); // Start with the most recent year

  useEffect(() => {
    if (progressBarRef.current) {
      progressBarRef.current.value =
        ((currentYearIndex + 1) / years.length) * 100
    }
  }, [years, currentYearIndex])

  const handlePrev = () => {
    setCurrentYearIndex((prev) => Math.max(0, prev - 1))
  }

  const handleNext = () => {
    setCurrentYearIndex((prev) => Math.min(years.length - 1, prev + 1))
  }

  const currentYear = years[currentYearIndex]
  const nextYear = years[currentYearIndex + 1]
  const currentArticles = articlesByYear[currentYear]
  const lastYear = years.length > 0 ? years[0] : 2;
  const updatedCurrentYear = isMobileView ? currentYearIndex + 1 : currentYear
  const udpatedLastYear = isMobileView ? years.length : lastYear

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 450)
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <Section className={classNames.commPress + " xxlarge mt-15"}>
      <Section classNames={classNames.container}>
        <h2 className={classNames.title}>Les articles de {currentYear}</h2>
      </Section>
      {currentArticles.map((article) => (
        <Section>
          <PressCardBlock
            data={article}
            key={article.id}
          />
        </Section>
      ))}
      <div className="pagination-view flex items-center justify-center gap-1 mt-6 mb-3">
        <button
          id="prev-btn"
          className="btn unstyled"
          onClick={handlePrev}
        >
          <img
            className="image centered"
            src="https://media.paritel.fr/paritel-www-dev/assets/pagination_arrow_left_e09dd1e248.svg"
            alt="fleche gauche"
          />
        </button>
        <span id="last-year"> {isMobileView ? updatedCurrentYear : lastYear}</span>
        <progress
          id="progressBars"
          max="100"
          ref={progressBarRef}
        >
          0%
        </progress>
        <span
          id="pagination-current"
          style={{
            opacity: 0.5,
            pointerEvents: nextYear ? "auto" : "none",
          }}
        >
          {!isMobileView ? nextYear ? nextYear : currentYear : udpatedLastYear}
        </span>
        <button
          id="next-btn"
          className="btn unstyled"
          onClick={handleNext}
        >
          <img
            className="image"
            src="https://media.paritel.fr/paritel-www-dev/assets/pagination_arrow_right_32981af1d4.svg"
            alt="fleche droite"
          />
        </button>
      </div>
    </Section>
  )
}
export const name = "ArticlesPresseParAnnee"

export const init = (componentData, pageContext) => {
  return (
    <ArticlesPresseParAnnee
      id={componentData.id}
      pageContext={pageContext}
    />
  )
}

export default ArticlesPresseParAnnee
